import styled, { CSSObject } from 'styled-components';
import { ICalloutPositionStyles } from '../callout-types';
import { Modal } from '../../modal';

export const CalloutLayer = styled(Modal).attrs((props: { layerStyles: ICalloutPositionStyles['layerStyles'], showModal?: boolean }) => props)`
    ${({ layerStyles }) => layerStyles as CSSObject}
    visibility: ${({ showModal }) => (showModal ? 'visible' : 'hidden')};
`;
